const preload = (load: () => Promise<unknown>) => {
  void load().catch(() => undefined);
};

export const preloadPrimaryTabs = () => {
  preload(() => import("../views/dashboard/index"));
  preload(() => import("../views/calendar/index"));
  preload(() => import("../views/hire/index"));
  preload(() => import("../views/social/index"));
  preload(() => import("../views/pages/vault/index"));
  preload(() => import("../views/pages/account/index"));
  preload(() => import("../views/messages/index"));
};
